import { useCallback } from "react";
import { useEventListener } from "../../../hooks/useEventListener";

interface UseKeyboardOptions {
  event?: "keydown" | "keyup" | "keypress";
  stopPropagation?: boolean;
  preventDefault?: boolean;
  disableGlobalEvent?: boolean;
}

export const useKeyboard = (
  callback: (event: any) => void,
  keyCode: number | number[],
  options: UseKeyboardOptions = {}
) => {
  const {
    event = "keydown",
    stopPropagation = true,
    preventDefault = true,
    disableGlobalEvent = false,
  } = options;

  const handleKeyEvent = useCallback(
    (event: any) => {
      const keyCodes = Array.isArray(keyCode) ? keyCode : [keyCode];
      if (keyCodes.includes(event.keyCode)) {
        if (preventDefault) {
          event.preventDefault();
        }
        if (stopPropagation) {
          event.stopPropagation();
        }
        callback(event);
      }
    },
    [keyCode, callback, preventDefault, stopPropagation]
  );

  useEventListener(
    event,
    handleKeyEvent,
    disableGlobalEvent ? undefined : window
  );
};
